module.exports = __webpack_public_path__ + "static/media/studio.abc8420e.png";